import React, { useState } from "react";
import { useFormik } from "formik";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { resendVerification, authErrorMessage } from "../_redux/authCrud";

export default function ResendVerification() {
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema: Yup.object().shape({
      email: Yup.string().email("Wrong email format").required("Email is required"),
    }),
    onSubmit: (values, { setSubmitting }) => {
      setErrorMessage("");
      resendVerification(values.email)
        .then(() => setIsSuccess(true))
        .catch(err => setErrorMessage(authErrorMessage(err, "We could not send the email. Please try again.")))
        .finally(() => setSubmitting(false));
    },
  });

  return (
    <div className="login-form login-forgot" style={{ display: "block" }}>
      <div className="text-center mb-10 mb-lg-20">
        <h3 className="font-size-h1">Resend verification email</h3>
        <div className="text-muted font-weight-bold">
          Enter the email address you registered with
        </div>
      </div>

      {isSuccess ? (
        <div className="alert alert-custom alert-light-success fade show mb-10" role="alert">
          <div className="alert-text font-weight-bold">
            If that email exists and isn't verified yet, a new link is on its way.
          </div>
        </div>
      ) : (
        <form onSubmit={formik.handleSubmit} className="form">
          {errorMessage && (
            <div className="alert alert-custom alert-light-danger mb-6" role="alert">
              <div className="alert-text font-weight-bold">{errorMessage}</div>
            </div>
          )}
          <div className="form-group fv-plugins-icon-container">
            <input
              type="email"
              className="form-control form-control-solid h-auto py-5 px-6"
              name="email"
              placeholder="Email"
              {...formik.getFieldProps("email")}
            />
            {formik.touched.email && formik.errors.email ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.email}</div>
              </div>
            ) : null}
          </div>
          <div className="form-group d-flex flex-wrap flex-center">
            <button
              type="submit"
              className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
              disabled={formik.isSubmitting}
            >
              Send link
            </button>
            <Link to="/auth/login">
              <button type="button" className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4">
                Back to login
              </button>
            </Link>
          </div>
        </form>
      )}
    </div>
  );
}
